import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Buildings, WarningCircle, SealCheck } from '@phosphor-icons/react';

const inputCls = 'bg-white text-[#0A0A0A] border-2 border-[#0A0A0A] rounded-md px-3 py-2 focus:outline-none focus:ring-0 focus:shadow-[4px_4px_0px_0px_rgba(10,10,10,1)] transition-shadow';

/** Company field: pick from the SLA / Companies directory (datalist) or type a new name; shows live duplicate warning. */
export const CompanyPicker = ({ id, testId, value, onChange, companyNames, duplicate }) => {
  const match = companyNames.find((c) => c.name.toLowerCase() === (value || '').trim().toLowerCase());
  return (
    <div>
      <div className="flex items-end justify-between">
        <Label htmlFor={id} className="text-xs font-bold uppercase tracking-wider text-[#0A0A0A]">Company Name</Label>
        <span className="text-[10px] font-bold text-[#404040] flex items-center gap-1"><Buildings size={12} weight="fill" /> pick from directory or type new</span>
      </div>
      <Input
        id={id}
        data-testid={testId}
        list={`${id}-list`}
        required
        autoComplete="off"
        placeholder="Start typing to pick a company…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`${inputCls} ${duplicate ? 'border-[#DC2626] bg-[#FEF2F2]' : ''}`}
      />
      <datalist id={`${id}-list`}>
        {companyNames.map((c) => <option key={c.name} value={c.name}>{c.has_sla ? 'SLA signed' : 'In directory'}</option>)}
      </datalist>
      {match && !duplicate && (
        <p className="text-[11px] font-bold mt-1 flex items-center gap-1 text-[#15803D]" data-testid={`${testId}-directory-hint`}>
          <SealCheck size={12} weight="fill" /> {match.has_sla ? 'SLA company from directory' : 'Company from directory'}
        </p>
      )}
      {duplicate && (
        <p className="text-[11px] font-bold mt-1 flex items-center gap-1 text-[#DC2626]" data-testid={`${testId}-duplicate-warning`}>
          <WarningCircle size={14} weight="fill" /> {duplicate.candidate_name} with this number is already in the Tracker for {duplicate.company_name}. Choose a different company or number.
        </p>
      )}
    </div>
  );
};
